module.exports = __webpack_public_path__ + "static/media/screen4.a3e8eaad.png";